import React, { useMemo } from 'react';
import { createFloatingParticles } from '../../utils/createFloatingParticles';
import './SeasonalEffect.css';
import './SakuraPetals.css';

const PETAL_COUNT = 25;
const MOBILE_PETAL_COUNT = 12;

function SakuraPetals() {
  const petals = useMemo(
    () => createFloatingParticles(PETAL_COUNT, {}),
    []
  );

  return (
    <div className="seasonal-effect sakura-petals" aria-hidden="true">
      {petals.map((petal, index) => (
        <span
          key={petal.id}
          className={`seasonal-particle sakura-petal${index >= MOBILE_PETAL_COUNT ? ' seasonal-particle--desktop' : ''}`}
          style={{
            '--particle-size': `${petal.size}px`,
            '--start-x': `${petal.startX}%`,
            '--delay': `${petal.delay}s`,
            '--duration': `${petal.duration}s`,
            '--drift': `${petal.drift}vw`,
            '--spin': `${petal.spin}deg`,
            '--particle-opacity': petal.opacity,
          }}
        />
      ))}
    </div>
  );
}

export default SakuraPetals;
